<template>
  <div class="profile-header">
    <div class="columns">
      <div class="column is-three-fifths header-left">
        <slot name="profile-header"></slot>
      </div>
      <div class="column profile-overview">
        <slot name="profile-overview"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="sass" scoped>
  .profile-header
    background: #fff
    -webkit-box-shadow: 0 4px 8px -3px #aaa
    box-shadow: 0 4px 8px -3px #aaa
    height: auto
    width: 100%
    border-top: 1px solid #eee
    .columns
      display: flex
      justify-content: space-between
      flex-wrap: wrap
      .header-left
        flex: 1
      .profile-overview
        flex: 2
        .columns .column
          flex: 1 1 0
          min-width: 0
          overflow-wrap: anywhere
          min-height: 80px
    &.is-inline
      box-shadow: none
      .columns
        align-items: center
        display: flex
        .header-title
          font-size: 1.15rem
          font-weight: 700
          padding-left: 0.75rem
        .header-subtitle
          padding-left: 0.75rem

    .columns
      margin: 0
      .column
        padding: 0.5rem 0.5rem
        &.header-left
          text-align: left
          color: #666
          font-weight: 700
          padding-left: 1.5rem
          display: flex
          flex-direction: column
          justify-content: center
          .header-title
            font-size: 1.5rem
            line-height: 2rem
            font-weight: 500
            color: #212529
          .header-subtitle
            padding-top: .25rem
            font-size: .85rem
            font-weight: 700
        &.profile-overview
  .profile-overview
    .columns
      align-items: stretch
      .column
        align-content: center
        &:first-child
          border-left: 1px solid #d9d9d9
          border-right: 1px solid #d9d9d9
        .column-content
          transform: perspective(1px)
          .column-title
            font-size: 1.15rem
            color: #000
            font-weight: 600
            overflow-wrap: anywhere
            word-break: break-word
          .column-subtitle
            font-size: .85rem
            color: #757575
  @media screen and (max-width: 70em)
    .profile-header > .columns
        display: block
</style>
